import { z } from "zod";
import { UserInvitationType } from "./types";
import { CivilStatus } from "../../../enums/civil-status";
import { Gender } from "../../../enums/gender";

export const RoleModelSchema = z.object({
  id: z.string().nonempty("Role ID is required."),
  name: z.string().nonempty("Role name is required."),
  displayName: z.string().nonempty("Role name is required."),
  role: z.string(),
});

export const userInvitationSchema = z
  .object({
    type: z.nativeEnum(UserInvitationType, {
      required_error: "Type is required",
    }),
    email: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    productCode: z.string().optional(),
    facilityCode: z.string().optional(),
    userId: z.string().optional(),
    // role: RoleModelSchema,
  })
  .refine(
    (data) => {
      if (data.type === UserInvitationType.Email) {
        return !!data.email;
      }
      return true;
    },
    {
      message: "Email is required.",
      path: ["email"],
    }
  )
  .refine(
    (data) => {
      if (data.email) {
        return z.string().email().safeParse(data.email).success;
      }
      return true;
    },
    {
      message: "Invalid email address.",
      path: ["email"],
    }
  )
  .refine(
    (data) => {
      if (data.type === UserInvitationType.UserFullname) {
        return !!data.firstName;
      }
      return true;
    },
    {
      message: "Please input first name.",
      path: ["firstName"],
    }
  )
  .refine(
    (data) => {
      if (data.type === UserInvitationType.UserFullname) {
        return !!data.lastName;
      }
      return true;
    },
    {
      message: "Please input last name.",
      path: ["lastName"],
    }
  );

export const userFormSchema = z.object({
  id: z.string().optional(),
  lastName: z.string().nonempty("Required"),
  firstName: z.string().nonempty("Required"),
  middleName: z.string().optional(),
  suffix: z.string().optional(),
  prefix: z.string().optional(),
  phoneNumber: z.string().optional(),
  phoneNumberOTP: z.string().optional(),
  emailOTP: z.string().optional(),
  customName: z.string().optional(),
  email: z.string().email("Required"),
  newEmail: z.string().email().optional(),
  newPassword: z.string().optional(),
  confirmPassword: z.string().optional(),
  newPhoneNumber: z.string().optional(),
  civilStatus: z.number(), //z.nativeEnum(CivilStatus, { required_error: "Civil Status is required" }),
  gender: z.number(), //.nativeEnum(Gender, { required_error: "Gender is required" }),
  productCode: z.string().optional(),
  facilityCode: z.string().optional(),
  role: RoleModelSchema,
  birthDate: z
    .string()
    .optional()
    .refine((d) => d === undefined || !isNaN(Date.parse(d)), {
      message: "Invalid date format",
    })
    .refine((d) => d === undefined || new Date(d) <= new Date(), {
      message: "Date should not be in the future",
    }),

  photoUrl: z.any().optional(),
  twoFactorEnabled: z.boolean().optional(),
  isDefaultPassword: z.boolean().optional(),
});

export const initialValues: z.infer<typeof userFormSchema> = {
  id: undefined,
  lastName: "",
  firstName: "",
  middleName: "",
  suffix: "",
  prefix: "",
  phoneNumber: "N/A",
  customName: "",
  email: "",
  newEmail: "",
  newPhoneNumber: "",
  newPassword: "",
  confirmPassword: "",
  phoneNumberOTP: "",
  emailOTP: "",
  civilStatus: CivilStatus.Single, // Assuming CivilStatus is an enum
  gender: Gender.Male, // Assuming Gender is an enum
  productCode: "",
  facilityCode: "",
  role: {
    id: "FqNf3m6uZTbdfrQrX1q8wQIRsttqjZJ8U7RvB6sTOavBWhXM20X3LQEpC12f+5na",
    name: "GroupAdmin",
    displayName: "Group Admin",
    role: "GroupAdmin",
  },
  birthDate: "",
  photoUrl: undefined,
  twoFactorEnabled: false,
  isDefaultPassword: false,
};

export type UserSchema = z.infer<typeof userInvitationSchema>;
export type UserFormSchema = z.infer<typeof userFormSchema>;
